import { createMultiPartRequest, createRequest } from '../helpers/api_utils';
import { SearchApplicantFilter } from '../types/job_applicant';
import { JobApplicantSearchRequest } from '../types/JobOpenings';
import { apiUrl } from './api_url';

const apiEndpoint = apiUrl + '/job-applicant';

export function searchCandidates(search: string, page: number, page_size: number, top_x: number) {
  const params = new URLSearchParams({
    search,
    page: page.toString(),
    page_size: page_size.toString(),
    top_x: top_x.toString(),
  });
  const url = `${apiEndpoint}/search_candidates?${params}`;
  return fetch(createRequest(url, 'POST', 'application/json', true));
}

export async function jobApplicantTwoD(
  searchObject: JobApplicantSearchRequest,
) {
  return fetch(
    createRequest(
      `${apiEndpoint}/2d-graph`,
      'POST',
      'application/json',
      true,
      searchObject,
    ),
  );
}

